module.exports = __webpack_public_path__ + "/images/cover-multi-ext-share.5e7c5a5.webp";